import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader } from '../Loader';
import styles from './GlobalLoader.module.scss';
import { OverlayLoaderTID } from './OverlayContext';
export function GlobalLoader() {
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.globalLoader,
        "data-testid": "global-loader",
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": OverlayLoaderTID,
                className: styles.overlay
            }),
            /*#__PURE__*/ _jsx(Loader, {})
        ]
    });
}
